import Container from "../Container/Container";
import "./CadastroContainer.css";

const CadastroContainer = (props) => {
  return <Container className="cadastro-container">{props.children}</Container>;
};

export default CadastroContainer;
